import React from 'react';
import SelectPlanoForm from './SelectPlano';
import { PlanoFormHeader } from './Header';
import SelectClientPlanoForm from './SelectClient';
import PlanoFormHorarios from './Horarios';
import { usePlanoForm } from './Context';

const PlanoForm = () => {
    const { plano, clientId } = usePlanoForm();

    return (
        <div className='lg:w-7/12 mx-auto'>
            <PlanoFormHeader />

            {
                !plano?._id && <SelectPlanoForm />
            }

            {
                !clientId && !!plano?._id && <SelectClientPlanoForm />
            }

            {
                !!clientId && !!plano?._id && <PlanoFormHorarios />
            }
        </div>
    );
};

export default PlanoForm;